export const ApiHelper = {
  get: async <T>(_url: string, _data?: Record<string, unknown>, _request?: RequestInit) =>
    ({}) as T,
  post: async <T>(_url: string, _data: Record<string, unknown>, _request?: RequestInit) =>
    ({}) as T,
};

export { default as useQuery } from "./useQuery";
export { default as useMutation } from "./useMutation";
